module.exports = __webpack_public_path__ + "img/ky.68e641e9.png";